import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { AppBar, Tabs, Tab } from '@material-ui/core';
import TopicBlock from '../LearningTopics/TopicBlock/TopicBlock';
import QscIndicators from './QscIndicators/QscIndicators';

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`qsc-tabpanel-${index}`}
    aria-labelledby={`qsc-tab-${index}`}
    {...other}
  >
    {value === index && (
      <TopicBlock>{children}</TopicBlock>
    )}
  </div>
);

const a11yProps = (index) => ({
  id: `qsc-tab-${index}`,
  'aria-controls': `qsc-tabpanel-${index}`,
});

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
  },
  careerNavTab: {
    borderRadius: 6,
    backgroundColor: '#fff',
    overflow: 'hidden',
  },
  tabRoot: {
    '& button': {
      padding: '14px 17px',
      textTransform: 'none',
      fontWeight: theme.typography.fontWeightMedium,
    },
    '& button:focus': {
      outline: 'none',
    },
    '& button.Mui-selected': {
      color: theme.palette.common.gamsPetroleumBlue,
    },
  },
  tabIndicator: {
    backgroundColor: theme.palette.common.gamsPetroleumBlue,
    height: 4,
  },
}));

const QscLearningTopics = ({ careerPaths, userRole, onGroupChange }) => {
  const classes = useStyles();
  const [value, setValue] = useState(0);

  // Filter out career paths with empty scores — same logic as LearningTopics
  const filteredCareerPaths = careerPaths
    ? careerPaths.filter(career => career.scores.length !== 0)
    : [];

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (onGroupChange && filteredCareerPaths[newValue]) {
      onGroupChange(filteredCareerPaths[newValue].groupId || null);
    }
  };

  // Notify parent of initial groupId on mount
  React.useEffect(() => {
    if (onGroupChange && filteredCareerPaths.length > 0) {
      onGroupChange(filteredCareerPaths[0].groupId || null);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [careerPaths]);

  return (
    <div className={classes.root}>
      <AppBar className={classes.careerNavTab} position="static" color="default" elevation={2}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="on"
          aria-label="qualification scorecard tabs"
          classes={{
            root: classes.tabRoot,
            indicator: classes.tabIndicator,
          }}
        >
          {filteredCareerPaths.map((career, index) => (
            <Tab key={index} label={career.name} {...a11yProps(index)} />
          ))}
        </Tabs>
      </AppBar>
      {filteredCareerPaths.map((career, index) => (
        <TabPanel key={index} value={value} index={index}>
          <QscIndicators scores={career.scores} userRole={userRole} />
        </TabPanel>
      ))}
    </div>
  );
};

export default QscLearningTopics;
